import { useState, useEffect } from "react";

const TypingIndicator = () => {
  const [dots, setDots] = useState('.');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? '.' : prev + '.'));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return <span className="italic text-gray-400">{dots}</span>;
};

export default TypingIndicator;